import { useState, useContext } from 'react';
import { Box } from '@mui/material';
import LoginModal403 from './LoginModal403';
import RootContext from '../../../util/root.context';

const LoginMain403 = () => {
  // const [state, setState] = useState({
  //   offers: [],
  //   devices: [],
  //   brands: [],
  //   discounts: [],
  //   selectedMobileOffer: null,
  //   // simOnly: localStore.getLocalStorage('BILLPAY_JOURNEY') !== 'true',
  //   // simOnly: false,
  // });
  const [loginModal, setLoginModal] = useState(true);
  const [onLoadingDisablecta, setOnLoadingDisablecta] = useState(false);
  // const [showLoader, setShowLoader] = useState(false);
  const { dispatch } = useContext(RootContext);

  return (
    <Box>
      {loginModal && (
        <LoginModal403
          enable={loginModal}
          setEnableModal={setLoginModal}
          // registrationIncompleteModal={registrationIncompleteModal}
          // onload={onMobileJourneyLogin}
          // mobile
          saveLoginInfo={dispatch}
          // showLoader={loader}
          // setShowLoader={setLoader}
          loaderText='logging in'
          onLoadingDisablecta={onLoadingDisablecta}
          setOnLoadingDisablecta={setOnLoadingDisablecta}
          // isR6Customer={isR6Customer}
          // openAccountCheck={openAccountCheck}
        />
      )}
    </Box>
  );
};

export default LoginMain403;
